<div id="backdrop" class="modal-backdrop fade" [ngClass]="{ show: showModal }"></div>

<div class="modal d-block fade" [ngClass]="{ show: showModal }" (click)="onClose()" id="Invite" tabindex="-1" role="dialog" aria-labelledby="modalIdLabel">
    <div class="modal-dialog" role="document" (click)="onDialogClick($event)">
        <div class="modal-content" >
            <div class="modal-header">
                <h5 class="col-sm-11 d-flex align-items-center">Convidar Parceiro</h5>
            
                <div class="col-sm-1 col text-right">
                    <div class="button-container">
                        <button nbButton status="primary" class="btn-close" (click)="onClose()" hero>
                            <i class="nb-close"></i>
                        </button>
                    </div>
                </div>
            </div>         
            <div class="modal-body" >
                <div [formGroup]="quoteForm" >
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                              <label for="group" class="label">Grupo da empresa</label>
                              <input type="text" nbInput fullWidth id="group" formControlName="group"
                                [status]="group?.errors?.required && (group?.hasError('minlength') || group?.hasError('maxlength')) ? 'danger' : 'primary'"
                                class="form-control" placeholder="Grupo da empresa">
                            
                                <ngx-validation-message label="Grupo da empresa"
                                [showRequired]="group?.errors?.required && group.touched"
                                [showMinLength]="group?.hasError('minlength')"
                                [showMaxLength]="group?.hasError('maxlength')" minLength=4
                                maxLength=10></ngx-validation-message>
    
                            </div>
                          </div>
                    </div>
    
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label for="email" class="label">Email</label>
                                <input type="text" nbInput fullWidth id="email" formControlName="email"
                                       [status]="(email?.errors?.required || email?.hasError('pattern')) && email.touched ? 'danger' : 'primary'"
                                       class="form-control"
                                       placeholder="Email">
                                <ngx-validation-message label="Email"
                                                        [showPattern]="email?.hasError('pattern') && email.touched"
                                                        [showRequired]="email?.errors?.required && email.touched" min=1 max=120></ngx-validation-message>
                              </div>
                          </div>
                    </div>

                </div>
                
            </div>
            <div class="modal-footer">
                <button nbButton status="primary" [disabled]="!quoteForm.valid" (click)="onSend()" hero>Salvar</button>
                <button nbButton status="info" (click)="onClose()" hero>Voltar</button>
            </div>
        </div>
    </div>
</div>